module.exports = __webpack_public_path__ + "img/banner_czsx.b6d0af43.png";